import { useTranslation } from 'react-i18next';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

export function Pagination({ currentPage, totalPages, pageSize, onPageChange, onPageSizeChange }: PaginationProps) {
  const { t } = useTranslation();

  if (totalPages <= 1) return null;

  return (
    <div className="flex flex-row items-center justify-end gap-3">
      <select
        value={pageSize}
        onChange={e => onPageSizeChange(+e.target.value)}
        className="bg-primary text-white rounded-full p-2 cursor-pointer text-sm"
      >
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={200}>200</option>
      </select>
      <button
        onClick={() => onPageChange(1)}
        disabled={currentPage <= 1}
        className="bg-primary text-white font-bold py-2 px-4 rounded-full disabled:opacity-50 text-sm"
      >
        «
      </button>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="bg-primary text-white font-bold py-2 px-4 rounded-full disabled:opacity-50 text-sm"
      >
        {t('prev')}
      </button>
      <span className="text-sm">{currentPage} / {totalPages}</span>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        className="bg-primary text-white font-bold py-2 px-4 rounded-full disabled:opacity-50 text-sm"
      >
        {t('next')}
      </button>
      <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage >= totalPages}
        className="bg-primary text-white font-bold py-2 px-4 rounded-full disabled:opacity-50 text-sm"
      >
        »
      </button>
    </div>
  );
}
